import { render } from "./DatosContactosAdministracion.vue?vue&type=template&id=bd77932e"
import script from "./DatosContactosAdministracion.vue?vue&type=script&lang=js"
export * from "./DatosContactosAdministracion.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vento-proveedores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__